<ng-container>
  <div class="news-categories-wrapper">
    <div class="section-name">{{ 'newsArticles.newsTitle' | cxTranslate }}</div>
    <ul [ngClass]="activeLanguage$ | async">
      <li (click)="selectCategory('ALL')" [ngClass]="{ active: activeNewsCategoryCode === 'ALL' }">
        {{ 'newsArticles.all' | cxTranslate }}
      </li>
      <ng-container *ngIf="newsCategory$ | async as data">
        <li
          *ngFor="let category of data.categories"
          [ngClass]="{ active: activeNewsCategoryCode === category.code }"
          (click)="selectCategory(category.code, category.name)"
        >
          {{ category.name }}
        </li>
      </ng-container>
    </ul>

    <div class="btn-group">
      <div mat-button [matMenuTriggerFor]="categoryMenu">
        <span class="label-wrapper">
          {{ activeNewsCategoryCode !== 'ALL' ? activeNewsCategoryName : ('newsArticles.all' | cxTranslate) }}
          <mat-icon class="expand-icon">expand_more</mat-icon>
        </span>
      </div>
      <mat-menu #categoryMenu="matMenu" class="custom-menu">
        <div
          mat-menu-item
          (click)="selectCategory('ALL')"
          [ngClass]="{ 'selected-item': activeNewsCategoryCode === 'ALL' }"
        >
          <mat-icon svgIcon="check" *ngIf="activeNewsCategoryCode === 'ALL'" class="check-icon"></mat-icon>
          <span class="category-label">{{ 'newsArticles.all' | cxTranslate }}</span>
        </div>
        <ng-container *ngIf="newsCategory$ | async as data">
          <div
            mat-menu-item
            *ngFor="let category of data.categories"
            (click)="selectCategory(category.code, category.name)"
            [ngClass]="{ 'selected-item': activeNewsCategoryCode === category.code }"
          >
            <mat-icon svgIcon="check" *ngIf="activeNewsCategoryCode === category.code" class="check-icon"></mat-icon>
            <span class="category-label">{{ category.name }}</span>
          </div>
        </ng-container>
      </mat-menu>
    </div>
  </div>
</ng-container>
